import { render, staticRenderFns } from "./TemplateHistory.vue?vue&type=template&id=7b0c1c9a&scoped=true&"
import script from "./TemplateHistory.vue?vue&type=script&lang=js&"
export * from "./TemplateHistory.vue?vue&type=script&lang=js&"
import style0 from "./TemplateHistory.vue?vue&type=style&index=0&id=7b0c1c9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0c1c9a",
  null
  
)

export default component.exports